module.exports = __webpack_public_path__ + "static/IMG-20200727-WA0022-4a1f237cdcf47e5e3e95290e554799fe.jpg";